module.exports = __webpack_public_path__ + "static/media/screenshot(21).3315a8ae.jpg";